(function () {
  'use strict';

  function initQuoteForm(section) {
    var interestSelect = section.querySelector('[data-quote-interest]');
    if (!interestSelect) return;

    var followUps = section.querySelectorAll('[data-follow-up]');

    function matchesFollowUp(followUpValue, selectedInterest) {
      return followUpValue.split('|').some(function (value) {
        return value.trim() === selectedInterest;
      });
    }

    function setFollowUpVisibility(followUp, show) {
      followUp.hidden = !show;
      followUp.setAttribute('aria-hidden', show ? 'false' : 'true');

      followUp.querySelectorAll('input, select, textarea').forEach(function (field) {
        field.disabled = !show;
      });
    }

    function updateFollowUps() {
      var selectedInterest = interestSelect.value;

      followUps.forEach(function (followUp) {
        var followUpValue = followUp.getAttribute('data-follow-up') || '';
        setFollowUpVisibility(followUp, matchesFollowUp(followUpValue, selectedInterest));
      });

      var zipField = section.querySelector('.sanders-quote-form__zip');
      var fulfillmentField = section.querySelector('.sanders-quote-form__fulfillment');

      if (selectedInterest === 'Delivery / pickup') {
        var deliveryNote = section.querySelector('.sanders-quote-form__follow-up--delivery [id^="quote-delivery-note"]');
        if (zipField && deliveryNote) {
          zipField.setAttribute('aria-describedby', deliveryNote.id);
        }
        if (fulfillmentField) {
          fulfillmentField.classList.add('sanders-quote-form__field--highlight');
        }
      } else {
        if (zipField) {
          zipField.removeAttribute('aria-describedby');
        }
        if (fulfillmentField) {
          fulfillmentField.classList.remove('sanders-quote-form__field--highlight');
        }
      }
    }

    interestSelect.addEventListener('change', updateFollowUps);
    updateFollowUps();
  }

  function initAll() {
    document.querySelectorAll('.sanders-quote-form').forEach(initQuoteForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.sanders-quote-form');
    if (section) initQuoteForm(section);
  });
})();
